import React from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./appRoutes";
import AuthProtected  from './AuthProtected';

// Maintenance mode
import { useMaintenanceMode } from '../hooks/useMaintenanceMode';
import MaintenancePage from '../pages/MaintenancePage';

const Index = () => {
    const { shouldShowMaintenancePage, loading } = useMaintenanceMode();

    // Show maintenance page if applicable
    if (!loading && shouldShowMaintenancePage) {
        return <MaintenancePage />;
    }

    return (
        <React.Fragment>
            <Routes>
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                {route.component}
                            </NonAuthLayout>
                        }
                        key={idx}
                    />
                ))}

                {authProtectedRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <AuthProtected>
                                <VerticalLayout>{route.component}</VerticalLayout>
                            </AuthProtected>
                        }
                        key={idx}
                    />
                ))}
            </Routes>
        </React.Fragment>
    );
};

export default Index;